import React from 'react';
import ImmutablePureComponent from 'react-immutable-pure-component';
import { unescape as unescapeHtml } from 'lodash';
import RelativeTimestamp from '../../../../brighteon/components/relative_timestamp';

export class FeedItem extends ImmutablePureComponent {

  processHeadline = (text) => {
    return unescapeHtml(text)
      .replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec));
  }

  render() {
    const {
      headline,
      date,
      link,
      newsSource,
      image,
    } = this.props;

    let image_url = image;

    if (!image_url) {
      image_url = 'https://cdn.brighteon.social/packs/media/images/brighteon-social/Icon-News-Gray-7baa87e528064c5256c8b340f515c84f.svg';
    }

    return (
      <div className='uncensored-news-feed__item d-flex'>
        <a className='mr5px' href={link}>
          <img src={image_url} className='mt7px w-62px h-62px object-fit-cover' alt='feed item' />
        </a>
        <a href={link} target='_blank'>
          <div className='uncensored-news-feed__item__description'>
            <span>{newsSource}</span> • <RelativeTimestamp timestamp={(new Date(date)).toISOString()} />
          </div>
          <div className='uncensored-news-feed__item__headline'>
            {this.processHeadline(headline)}
          </div>
        </a>
      </div>
    );
  }

}
